import { replaceEqualDeep } from '@tanstack/react-query'
import type { IOrdinalMarketSummary } from 'api/api'

export function ordinalMarketQueryOptions(initialMarket?: IOrdinalMarketSummary | null) {
    return {
        structuralSharing: (previous: unknown, incoming: unknown) => {
            const old = previous as IOrdinalMarketSummary | null | undefined
            const next = incoming as IOrdinalMarketSummary | null | undefined
            if (old && Number(old.state_revision ?? 0) > Number(next?.state_revision ?? 0)) {
                return previous
            }
            return replaceEqualDeep(previous, incoming)
        },
        initialData: initialMarket ?? undefined,
        staleTime: 60_000,
        // Receipts have no live stream payload, and even a recent cache entry
        // can predate their sale. Override the app's disabled mount refresh.
        refetchOnMount: initialMarket ? false : ('always' as const),
    }
}
